import React from 'react';
import pricingMonthlyImg from '../../assets/images/pricing1.webp';
import pricingAnnualImg from '../../assets/images/pricing2.webp';
import playStoreBadge from '../../assets/images/black_google_play.webp';
import appStoreBadge from '../../assets/images/black_appstore.webp';
import PlayStoreLink from './PlayStoreLink';
import AppStoreLink from './AppStoreLink';
import { siteCopy } from '../../content/siteCopy';

const PLAN_IMAGES = {
  monthly: pricingMonthlyImg,
  annual: pricingAnnualImg,
};

const PricingPlans = ({ innerPage = false }) => {
  const { pricing } = siteCopy;
  const { section, plans, includes, disclosure, trialLabel } = pricing;

  return (
    <section
      className={`row_am pricing_section${innerPage ? ' inner_page' : ''}`}
      data-aos="fade-in"
      data-aos-duration={1500}
      id="pricing_sec"
    >
      <div className="pricing_inner">
        <div className="container">
          <div
            className="section_title"
            data-aos="fade-up"
            data-aos-duration={1500}
            data-aos-delay={300}
          >
            <span className="title_badge">{section.badge}</span>
            <h2>{section.title}</h2>
            {section.intro ? <p>{section.intro}</p> : null}
          </div>

          <div className="pricing_pannel" data-aos="fade-up" data-aos-duration={1500}>
            <div className="row justify-content-center">
              {plans.map((plan, index) => (
                <div className="col-md-5 col-lg-5" key={plan.id}>
                  <div
                    className={`pannel_block${plan.highlighted ? ' highlited_block' : ''}`}
                    data-aos="fade-up"
                    data-aos-duration={1500}
                    data-aos-delay={index * 100}
                  >
                    {plan.hasTrial ? <span className="offer">{trialLabel}</span> : null}
                    <div className="pkg_icon">
                      <img src={PLAN_IMAGES[plan.id] ?? pricingMonthlyImg} alt="" aria-hidden="true" />
                    </div>
                    <div className="heading">
                      <h5>{plan.name}</h5>
                    </div>
                    <div className="pricing">
                      <h3>
                        {plan.price} <span>{plan.period}</span>
                      </h3>
                    </div>
                    {plan.description ? <p className="trial_txt">{plan.description}</p> : null}
                    <ul className="features">
                      {includes.map((feature) => (
                        <li key={feature}>
                          <span className="icon">
                            <i className="icofont-check-circled" />
                          </span>
                          <p>{feature}</p>
                        </li>
                      ))}
                    </ul>
                    <ul className="app_btn">
                      <li>
                        <PlayStoreLink>
                          <img className="blue_img" src={playStoreBadge} alt="Get it on Google Play" />
                        </PlayStoreLink>
                      </li>
                      <li>
                        <AppStoreLink>
                          <img className="blue_img" src={appStoreBadge} alt="Download on the App Store" />
                        </AppStoreLink>
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {disclosure ? (
            <p
              className="trial_txt text-center"
              data-aos="fade-up"
              data-aos-duration={1500}
              style={{ maxWidth: '42rem', margin: '1.5rem auto 0' }}
            >
              {disclosure}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;
